import { render, staticRenderFns } from "./InstituteTable.vue?vue&type=template&id=2d169bb6"
import script from "./InstituteTable.vue?vue&type=script&lang=js"
export * from "./InstituteTable.vue?vue&type=script&lang=js"
import style0 from "./InstituteTable.vue?vue&type=style&index=0&id=2d169bb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports